// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__oVY_D","inputDescription":"styles_inputDescription__3GvVk"};